import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CircleCheckBig } from 'lucide-react';

const JobNotification = ({ show, count, onClose }) => {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 300, damping: 30 }}
          className="fixed bottom-10 left-1/2 transform -translate-x-1/2 z-50 flex items-center bg-white px-6 py-4 rounded-lg shadow-lg border border-gray-200"
        >
          <CircleCheckBig className="text-green-500 mr-3" size={24} />
          <p className="font-medium text-gray-800">
            <span className="text-green-600 font-bold">{count}</span> {count === 1 ? 'new job' : 'new jobs'} loaded
          </p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default JobNotification;